<!--客服侧边栏组件-->
<template>
  <div class="service-container">
    <!-- <el-tooltip effect="light" raw-content content="<span style='font-size:16px;'>联系电话：173XXXX5623</span>" placement="left"> -->
<!--    <el-tooltip effect="light" raw-content :content="serveconsult" placement="left">-->
      <!-- <router-link class="item-content" to="/serveconsult">
        <div class="icon">
          <span class="fa fa-commenting-o"></span>
        </div>
        <div class="name">服务咨询</div>
      </router-link> -->
    <!-- </el-tooltip> -->
    <!-- <el-tooltip effect="light" raw-content content="<span style='font-size:16px;'>联系电话：156XXXX5423</span>" placement="left"> -->

    <!--    <el-tooltip effect="light" raw-content :content="appconsult" placement="left">-->
      <!-- <router-link class="item-content" to="/appconsult">
        <div class="icon">
          <span class="fa fa-windows"></span>
        </div>
        <div class="name">应用咨询</div>
      </router-link> -->
    <!-- </el-tooltip> -->

    <!-- 联系客服 -->
    <!-- <el-tooltip effect="light" raw-content content="<span style='font-size:16px;'>联系电话：147XXXX5623</span>" placement="left"> -->

    <!--    <el-tooltip effect="light" raw-content :content="cusconsult" placement="left">-->
      <!-- <router-link class="item-content" to="/cusconsult">
        <div class="icon">
          <span class="fa fa-phone"></span>
        </div>
        <div class="name">联系客服</div>
      </router-link>
    </el-tooltip> -->
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
const store = useStore()
// const serveconsult = computed(() => store.getters.getServeconsult)
// const appconsult = computed(() => store.getters.getAppconsult)
// const cusconsult = computed(() => store.getters.getCusveconsult)
</script>

<style lang="scss" scoped>
.service-container{
  background-color: #efefef;
  box-shadow: 1px 1px 3px #ccc;
  margin-top: -100px;
  border-top-left-radius:3px;
  border-bottom-left-radius: 3px;
  .item-content{
    font-size:12px;
    width:50px;
    padding: 5px;
    cursor:pointer;
    color:#606266;
    border-bottom:1px solid #dfdfdf;
    &:last-child{
      border: none;
    }
    .icon{
      width: 50px;
      height: 26px;
      margin:5px 0;
      .fa{
        font-size: 24px;
      }
    }
    .name{
      margin-bottom:5px;
    }
    &:hover{
      color: #fa8231;
    }
  }
}
</style>
